<div class="modal">

  <button app-button buttonTheme="dark" buttonType="white" buttonShape="circle" type="button" (click)="closeDialog()" title="Close"
    [attr.aria-label]="'Close'" class="modal__close">
    <app-icon icon="times" size="lg">
    </app-icon>
  </button>

  <div class="modal__contents" #modalContents>
    <iframe [src]="url" class="modal__frame">
    </iframe>
  </div>

</div>